export default {
  clientAndPartners: {
    metatag: {
      title: 'SIS Innov & Tech - Clients and Partners',
      description: 'Find out more about the SIS Innov & Tech clients and partners',
    },
  },
}
